import gql from "graphql-tag";

export const getProducts = gql`
  query GetProductsById($ids: [ID!]!) {
    products(ids: $ids) @client(always: true)
  }
`;

export default getProducts;
